import { ISearchFilterRef } from '@/components';
import { MasterInfoEnum, WindowPostActionType } from '@/constant';
import { ApiResponseEnum } from '@/services';
import { CommonActions } from '@/stores';
import { navigateCreateOrDetail } from '@/utils';
import { RefObject, useCallback } from 'react';
import { useDispatch } from 'react-redux';

type Params = {
	toCreatePathName?: string;
	searchFilterRef?: RefObject<ISearchFilterRef>;
	callbackAfterClosePopup?: (data?: any) => void;
};

type CreateSubmitParams = {
	pathName?: string;
	callbackSuccess?: (data?: any) => void;
};

export const useCreateListSubmit = (params: Params) => {
	const { toCreatePathName, searchFilterRef, callbackAfterClosePopup } = params;

	const dispatch = useDispatch();
	const onCreateSubmit = useCallback(
		(createParams?: CreateSubmitParams) => {
			const { pathName, callbackSuccess } = createParams || {};

			if (!toCreatePathName && !pathName) return;

			const popup = navigateCreateOrDetail(pathName || toCreatePathName || '');

			if (popup) {
				popup.addEventListener(
					'message',
					(event) => {
						if (
							(typeof event?.data === 'string' &&
								event?.data === ApiResponseEnum.SUCCESS) ||
							event?.data?.message === ApiResponseEnum.SUCCESS
						) {
							popup?.close();

							searchFilterRef?.current?.resetSearch?.();

							callbackSuccess?.(event?.data?.values);
						}

						if (event?.data?.action) {
							const action = event?.data?.action;

							switch (action) {
								case WindowPostActionType.RELOAD_PUBLIC_FRANCHISE_AGRICULTURE:
									dispatch(
										CommonActions.getListCommonRequest({
											type: MasterInfoEnum.PUBLIC_FRANCHISE_AGRICULTURE,
											params: {},
										})
									);
									break;
								case WindowPostActionType.RELOAD_HEADER_PROGRAM:
									dispatch(CommonActions.resetHeaderProgram());
									dispatch(
										CommonActions.getListCommonRequest({
											type: MasterInfoEnum.PROGRAM,
											params: {},
											callback: () => {
												popup?.close();
												searchFilterRef?.current?.resetSearch?.();
											},
										})
									);
									break;
								case WindowPostActionType.RELOAD_PROGRAM_STATISTIC:
									callbackAfterClosePopup?.(event?.data?.values);
									break;
								case WindowPostActionType.RELOAD_ASSIGNMENT_CALENDAR:
									callbackSuccess?.(event?.data?.values);
									break;
								default:
									break;
							}
						}

						let timer = setInterval(() => {
							if (popup?.closed) {
								clearInterval(timer);
								window.removeEventListener('message', () => {});
							}
						}, 1000);
					},
					false
				);
			}

			return popup;
		},
		[toCreatePathName, searchFilterRef, callbackAfterClosePopup]
	);

	return {
		onCreateSubmit,
	};
};
